import { get, post } from '../../../../services/request';

// Fetch Notes Edit Data
export const getStrategicCapsNotesEditData = async (payload) => {
    try {
        const response = await post('Common/GetBlockPlanningReportNote', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Save Notes Data
export const saveStrategicCapsNotesData = async (payload) => {
    try {
        const response = await post('Common/UpdateBlockPlanningReportNote', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Delete Report
export const deleteStrategicCapsReport = async (id) => {
    try {
        const response = await post(`CapsVsDemandBlockPlanning/DeleteReport?id=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// //--------Delete  Report---//
// export const deleteStrategicCapsVsDemandRequest = (id) => {
//     return get(`CapsVsDemandBlockPlanning/DeleteReport=${id}`);
// }

// Export Report
export const exportStrategicCapsReport = async (id) => {
    try {
        const response = await get(`CapsVsDemandBlockPlanning/ExportBlockCapacityVsDemandReport?BlockPlanningCapsVsDemandTableID=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Reports with Pagination
export const getStrategicCapsReportsWithPagination = async (payload) => {
    try {
        const response = await post('CapsVsDemandBlockPlanning/GetAllReportsWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Dropdown Data
export const getStrategicCapsDropdownData = async () => {
    try {
        const response = await get('CapsVsDemandBlockPlanning/GetCapsVsDemandBlockDDList');
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Filter Dropdown Data
export const getFilterStrategicCapsDropdownData = async () => {
    try {
        const response = await get('CapacityTableBlockPlanning/GetBlockCapacityFilterDDModel');
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Week Quarter Dropdown Data
export const getWeekQuarterCapsDropdownData = async (payload) => {
    try {
        const response = await get('Common/GetWeekQuarterByMonthYear', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Surplus Worklist Data
export const getWRVUSurplusWorklistData= async (payload) => {
    try {
        // Backend route historically used a misspelling ("Worlist") — keep for compatibility
        const response = await post('CapsVsDemandBlockPlanning/GetCapacityVsDemandTableSurplusWorlistViewDataWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};



// Fetch wRVU Surplus (Gap) View Table Data
export const getWRVUSurplusData = async (payload) => {
    try {
        const response = await post('CapsVsDemandBlockPlanning/GetCapacityVsDemandTableSurplusViewDataWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch FTE Surplus (Gap) View Table Data
export const getFTESurplusData = async (payload) => {
    try {
        const response = await post('CapsVsDemandBlockPlanning/GetCapacityVsDemandTableFTESurplusViewDataWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Legend Data
export const getLegendData = async () => {
    try {
        const response = await get('SiteOnboardingPlanner/GetOnboardingSiteDemandPlannerLegend');
        return response;
    } catch (error) {
        throw error;
    }
};

// Draft report
export const draftStrategicCapsReport = (payload) => {
    try {
        return post('CapsVsDemandBlockPlanning/DraftBlockCapacityVsDemandReport', payload);
    } catch (error) {
        throw error;
    }
};

// Publish report
export const publishStrategicCapsReport = (payload) => {
    try {
        return post('CapsVsDemandBlockPlanning/PublishBlockCapacityVsDemandPlanningTableReport', payload);
    } catch (error) {
        throw error;
    }
};

// filter apply save report
export const filterStrategicCapsApplyReport = (payload) => {
    try {
        return post('CapsVsDemandBlockPlanning/SaveBlockCapacityVsDemandFilter', payload);
    } catch (error) {
        throw error;
    }
};


// RPCE and Worklist report
export const getWorklistByRPCEID = (RPCEID) => {
    try {
        return post(`Common/GetWorkListByRPCEIds?rpceIds=${RPCEID}`);
    } catch (error) {
        throw error;
    }
};

// GetBlockPlanningCapacityVsDemandTableReport report
export const getBlockPlanningCapacityVsDemandTableReport = (payload) => {
    try {
        return post('CapsVsDemandBlockPlanning/GetBlockPlanningCapacityVsDemandTableReport', payload);
    } catch (error) {
        throw error;
    }
};

// Fetch Caps vs Demand Filter By ID
export const getCapsVsDemandFilterByID = async (id) => {
    try {
        const response = await get(
            `CapsVsDemandBlockPlanning/GetBlockCapacityVsDemandFilterByID?BlockPlanningCapsVsDemandTableID=${id}`
        );
        return response;
    } catch (error) {
        throw error;
    }
};
